import {
  ClickAwayListener,
  Paper,
  Popper,
  withStyles,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { fontColor } from "../../assets/jss/appHealth.style";
import GraphicIcon from "../../components/Icon/graphicIcon";

const PainelInformacoesAgenda = observer(
  ({ classes, openDrawer, atendimentoStore }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);

    const handleClick = (event) => {
      const { currentTarget } = event;
      setAnchorEl(currentTarget);
      setOpen(!open);
    };

    useEffect(() => {
      
    }, [atendimentoStore.relatorioAgendamentos]);

    const onClickIcon = () => {
      setOpen(!open);
    };

    const SituacaoAgendamento = ({ situacao, quantidade, item }) => {
      const mapSituacao = {
        AGENDADO: {
          label: "Agendado: ",
          color: "#52d5fc",
        },
        CONFIRMADO: {
          label: "Confirmado: ",
          color: "#00B0AE",
        },
        AGUARDANDO: {
          label: "Aguardando: ",
          color: "#FBBF6D",
        },
        ATENDENDO: {
          label: "Atendendo: ",
          color: "#657496",
        },
        ATENDIDO: {
          label: "Atendido: ",
          color: "#9B69FF",
        },
        CANCELADO: {
          label: "Cancelado: ",
          color: "#f50057",
        },
        FALTOU: {
          label: "Faltou: ",
          color: "#FC71B4",
        },
        TOTAL: {
          label: "Total: ",
          color: "#505050",
        },
      };

      return (
        <div className={classes.item}>
          <div
            className={classes.circle}
            style={{ backgroundColor: mapSituacao[situacao].color }}
          />
          <div
            className={classes.label}
            style={{ color: mapSituacao[situacao].color }}
          >
            {mapSituacao[situacao]?.label}
          </div>
          <div
            className={classes.label}
            style={{ color: mapSituacao[situacao].color }}
          >
            {quantidade}
          </div>
        </div>
      );
    };

    return (
      <div>
        <div className={classes.divFiltro}>
          <div
            onClick={(e) => handleClick(e)}
            className={classNames(classes.buttonFilter, {
              [classes.buttonFilterCircle]: !openDrawer,
              [classes.buttonSelected]: open,
            })}
          >
            <GraphicIcon
              className={classNames(classes.filterIcon, {
                [classes.filterIconSelected]: open,
              })}
              size={22}
              onClick={() => onClickIcon()}
            />
            {openDrawer && <div> Filtrar </div>}
          </div>
          <Popper
            open={open}
            anchorEl={anchorEl}
            placement={"bottom-end"}
            className={classes.popper}
          >
            <ClickAwayListener onClickAway={() => setOpen(false)}>
              <Paper className={classes.typography}>
                <div className={classes.agendamentos}> Agendamentos: </div>
                <div className={classes.checkboxOptions}>
                  <div className={classes.situacoes}>
                    {atendimentoStore.relatorioAgendamentos.map((item) => {
                      return (
                        <div className={classes.item}>
                          <SituacaoAgendamento
                            situacao={item.situacao}
                            quantidade={item.quantidade}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Paper>
            </ClickAwayListener>
          </Popper>
        </div>
      </div>
    );
  }
);

const styles = {
  content: {
    display: "flex",
  },
  typography: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "10px",
    padding: "10px",
  },
  agendamentos: {
    display: "flex",
    color: "#505050",
    fontWeight: "bold",
  },
  checkboxOptions: {
    display: "flex",
    flexDirection: "column",
  },
  filterIcon: {
    color: "#868686",
  },
  filterIconSelected: {
    color: "#fff",
  },
  buttonFilter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonFilterCircle: {
    borderRadius: "50%",
    height: "32px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
    display: "flex",
    background: "#F2F2F2",
    width: "32px",
  },
  buttonSelected: {
    color: "#fff",
    backgroundColor: "#868686",
  },
  popper: {
    zIndex: 9999,
    left: "40px !important",
  },
  divFiltro: {
    display: "flex",
    color: "#F9BE73",
    cursor: "pointer",
  },
  situacoes: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    color: fontColor,
  },
  item: {
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  circle: {
    display: "block",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    marginRight: "5px",
    background: "red",
  },
  label: {
    fontSize: "12px",
    gap: "5px",
  },
};

const stores = ["atendimentoStore"];
const PainelInformacoesAgendaWrapper = withStyles(styles)(
  PainelInformacoesAgenda
);
export default inject(stores)(PainelInformacoesAgendaWrapper);
